import { webApiUrl } from "./constants";
import { Company } from "./interfaces/company";
import CompanyFromServer from "./interfaces/companyFromServer";
import { UpdateCompanyRequest } from "./interfaces/updateCompanyRequest";
import { DeactivateCompanyRequest } from "./interfaces/DeactivateCompanyRequest";
import { ReactivateCompanyRequest } from "./interfaces/ReactivateCompanyRequest";

export const mapCompanyFromServer = (data: CompanyFromServer): Company => ({
  companyId: data.companyId,
  companyName: data.companyName,
  accountNumber: data.accountNumber,
  licenses: data.licenses,
  licensesMobileCount: data.licensesMobileCount,
  trialLicenses: data.trialLicenses === null ? 0 : data.trialLicenses,
  isActive: data.isActive,
  terminalYN : data.terminalYN,
  licenseChanges: [],
});

export const getCompaniesAsync = async (token: string): Promise<Company[]> => {
  let request = new Request(`${webApiUrl}/Company/companies`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    const body = await response.json();

    return body.map(mapCompanyFromServer);
  } else {
    return [];
  }
};

export const getInactiveCompanies = async (
  token: string
): Promise<Company[]> => {
  let request = new Request(`${webApiUrl}/Company/inactive`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    const body = await response.json();

    return body.map(mapCompanyFromServer);
  } else {
    return [];
  }
};

export const getCompanyAsync = async (
  accountNumber: number,
  token: string
): Promise<Company> => {
  const request = new Request(`${webApiUrl}/Company/${accountNumber}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    const body = await response.json();

    return mapCompanyFromServer(body);
  } else {
    return {
      companyId: 0,
      companyName: "",
      accountNumber: 0,
      licenses: 0,
      licensesMobileCount: 0,
      trialLicenses: 0,
      isActive: false,
      terminalYN: false,
      licenseChanges: [],
    };
  }
};

export const updateCompany = async (
  updatedCompany: UpdateCompanyRequest,
  token: string
): Promise<boolean> => {
  const request = new Request(`${webApiUrl}/Company`, {
    method: "post",
    body: JSON.stringify(updatedCompany),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    return true;
  } else {
    return false;
  }
};

export const activateCompany = async (
  reactivatedCompany: ReactivateCompanyRequest,
  token: string
): Promise<boolean> => {
  const request = new Request(`${webApiUrl}/Company/activate`, {
    method: "post",
    body: JSON.stringify(reactivatedCompany),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) return true;
  else return false;
};

export const deactivateCompany = async (
  deactivatedCompany: DeactivateCompanyRequest,
  token: string
): Promise<boolean> => {
  const request = new Request(`${webApiUrl}/Company/deactivate`, {
    method: "post",
    body: JSON.stringify(deactivatedCompany),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) return true;
  else return false;
};
